@use "../../../../tti-design-styles/src/organisms/footer-link/" as *;
